import { render, staticRenderFns } from "./PqtMeasurementSpecifications.vue?vue&type=template&id=dfb51478"
import script from "./PqtMeasurementSpecifications.vue?vue&type=script&lang=ts"
export * from "./PqtMeasurementSpecifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports